import { useEffect, useState } from 'react'

import Api from 'services/api'
import { Status } from 'types/RemoteConfig'

const useRemoteConfigStatus = (deviceId: string, compatible: boolean) => {
  const [status, setStatus] = useState<Status | null>(null)

  useEffect(() => {
    setStatus(null)

    const poll = () => {
      if (compatible) {
        Api.RemoteConfig.status(deviceId)
          .then((res: Status | null) => {
            setStatus((res))
          }).catch(() => {
            setStatus(null)
          })
      }
    }

    poll()

    const pollingInterval = setInterval(poll, 4000) // poll once a 4 secconds

    return () => clearInterval(pollingInterval)
  }, [deviceId, compatible])

  return { status }
}

export default useRemoteConfigStatus
